export default "__VITE_ASSET__fe4e6a5f__"